import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { NETWORK_CAP_RECURRENCE } from 'constants/logic';
import { reduxFormPropTypes, schedulePropTypes } from 'constants/propTypes';

import Confirm from 'components/Confirm';
import { Fieldset, RadioButton } from 'components/Form';
import Message from 'components/Message';
import { networkCapRecurrenceModalMessages as messages } from './ScheduleDetail.messages';

import ProjectedSpotsConfirmation from '../ProjectedSpotsConfirmation';

const NetworkCapRecurrenceModal = ({
  canOnlyToggleNonRecurring,
  displayRecommendedSpots,
  handleSubmit,
  networkCap,
  schedule,
}) => {
  const { startDateTime } = schedule;

  return (
    <Confirm
      className="network-recurrence-modal"
      title={<Message message={messages.setCapTo} values={{ networkCap }} />}
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.update} />}
      onConfirm={handleSubmit}
      size="extended">
      {({ title, buttons, bodyClass }) => (
        <>
          {title}
          <div className={bodyClass}>
            <Fieldset>
              <Field
                name="recurrence"
                value={NETWORK_CAP_RECURRENCE.THIS_INSTANCE}
                type="radio"
                component={RadioButton}>
                <Message message={messages.thisInstance} />
              </Field>

              {!canOnlyToggleNonRecurring && (
                <Field
                  name="recurrence"
                  value={NETWORK_CAP_RECURRENCE.ALL_FUTURE_INSTANCES}
                  type="radio"
                  component={RadioButton}>
                  <Message message={messages.futureInstances} values={{ startDateTime }} />
                </Field>
              )}
            </Fieldset>
            {displayRecommendedSpots && <ProjectedSpotsConfirmation networkCap={networkCap} schedule={schedule} />}
          </div>
          {buttons}
        </>
      )}
    </Confirm>
  );
};

NetworkCapRecurrenceModal.propTypes = {
  canOnlyToggleNonRecurring: PropTypes.bool,
  displayRecommendedSpots: PropTypes.bool,
  networkCap: PropTypes.number,
  schedule: PropTypes.shape(schedulePropTypes),
  ...reduxFormPropTypes.form,
};

export default NetworkCapRecurrenceModal;
